// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___2dVnM","skeleton-loading":"styles__skeleton-loading___lgWvP","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___WY4pR","skeleton-loader-gradient":"styles__skeleton-loader-gradient___1GQBD","commons":"styles__commons___jxUQr","skeletonText":"styles__skeletonText___1EIaD","cardContainerClasses":"styles__cardContainerClasses___1Er0X","headerSectionSkeleton":"styles__headerSectionSkeleton___1bwNs","skeletonSubTitle":"styles__skeletonSubTitle___3acV7","containerSelect":"styles__containerSelect___3R-sL","button":"styles__button___2fapW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/ContractsAndOrdersSkeleton/styles.css
// module id = 2538
// module chunks = 0